import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ZXingScannerComponent } from 'angular-weblineindia-qrcode-scanner';

@Component({
  selector: 'app-qrcode-scanner',
  templateUrl: './qrcode-scanner.component.html',
  styleUrls: ['./qrcode-scanner.component.scss']
})
export class QrcodeScannerComponent implements OnInit {
  @ViewChild('scanner', { static: false }) scanner: ZXingScannerComponent;
  constructor(private router:Router,@Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {

  }
  scanSuccessHandler(event){
    
    this.document.location.href = event;


  }
  doSomething(): void {
    this.scanner.device = this.getBackCamera();
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    console.log(devices);
    // this.availableDevices = devices;
    // this.hasDevices = Boolean(devices && devices.length);
  }
 
  /**
   * Returns the back camera for ya.
   */
  getBackCamera() {
    return null;
  }
  scanErrorHandler(event){
    // console.log(event);
  }
  scanFailureHandler(event){
    // console.log(event);
  }
  scanCompleteHandler(event){
    //console.log("complete",event);
  }
}